import React, { Component } from 'react'
import api from '../services/api.service'
import downloadService from '../services/download.service'

interface Props {
  path: string
  text: string
}

export default class DownloadLink extends Component<Props> {
  handleClick = () => {
    const { path, text } = this.props
    api.client('backend', 'json')
      .get(path)
      .then(data => {
        downloadService.download(data.data, text)
      }).catch(() => {})
  }

  render () {
    const { path, text } = this.props
    return path && (
      <div
        onClick={this.handleClick}
        className="cursor-pointer text-blue-400">
        {text}
      </div>
    )
  }
}
